<template>
  <div v-cloak>
    <t-form ref="form" @submit.prevent>
      <ContactInformationFormPart @result="onResult" @change="onChange" />

      <LeadSubmitFormPart
        ref="leadSubmit"
        :is-optional="true"
        hidden
        @change="onChange"
        @leadPostError="onLeadPostError"
        @leadPostInvalid="onLeadPostInvalid"
        @leadPostValid="onLeadPostValid"
        @result="onResult"
      />
    </t-form>
  </div>
</template>

<script>
import LeadSubmitFormPart from 'chimera/all/components/form/parts/LeadSubmitFormPart'
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import { field as addressPostalField } from 'chimera/all/components/form/fields/addressPostal/AddressPostalRadioField.vue'
import usesReachedContactFormTracking from 'chimera/all/mixins/usesReachedContactFormTracking'
import ErrorPage from 'chimera/all/themes/blueflow/page/ErrorPage'
import ContactInformationFormPart from '~/components/form/part/contactInformation/ContactInformationFormPart.PD-10913'
import ThankYouPage from '~/pages/offertes-aanvragen/aanvraag-afgerond'

export default {
  name: 'ContactInformationFormStep',

  components: {
    ContactInformationFormPart,
    LeadSubmitFormPart,
  },

  extends: AbstractFormStep,

  mixins: [usesReachedContactFormTracking],

  /**
   * @returns {{willTransitionOnValid: boolean}}
   */
  data() {
    return {
      willTransitionOnValid: true,
    }
  },

  /**
   * Pass through the submit event given from FormShell
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit', this.onSubmit)
  },

  methods: {
    /**
     * @param {object} result
     */
    onResult(result) {
      AbstractFormStep.methods.onResult.call(this, result)

      const { field, isValid, value } = result

      // PD-10913: CTA path skips postcode.
      if (
        field === addressPostalField &&
        isValid &&
        !this.$store.getters['lead/getData']('postal')
      ) {
        this.$store.dispatch('lead/add', {
          key: 'postal',
          value,
          origin: 'ContactInformationFormStep',
        })
      }
    },

    /**
     * Perform lead post.
     * Based on inner logic of `postLead` the callback will be in `onLeadPost*` methods.
     */
    transition() {
      this.$refs.leadSubmit.postLead()
    },

    /**
     * On successful lead post
     */
    onLeadPostValid() {
      this.routeTo(ThankYouPage)
    },

    /**
     * On invalid lead post
     */
    onLeadPostInvalid() {
      this.routeTo(ErrorPage)
    },

    /**
     * Lead post resulted in an error
     */
    onLeadPostError() {
      this.routeTo(ErrorPage)
    },
  },
}
</script>
